<template>
  <GlideTranslation
    :disabled="expanded"
    :callback="callback"
  >
    <div
      :class="[side, { expanded }]"
      class="half"
    >
      <div
        v-if="sidelines"
        class="sidelines"
      />
      <div class="baseline"/>
      <div class="mark"/>
    </div>
  </GlideTranslation>
</template>

<script>
  export default {
    props: {
      side: {
        type: String,
        required: true,
        validator: side => ['top', 'right', 'bottom', 'left'].includes(side),
      },
      expand: {
        type: Boolean,
        default: false,
      },
      sidelines: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        expanded: !this.expand,
      };
    },
    methods: {
      callback({ y }) {
        if (y < 0.25) {
          return;
        }

        this.expanded = true;
      },
    },
  };
</script>

<style
  scoped
  lang="scss"
>
  $border-width: 2px;
  $transition-duration: duration(fast);
  $transition-timing-function: timing-function(decelerate);
  // @function 2px solid inherit {
  //   @return 2px solid inherit;
  // }

  .half {
    position: relative;
    display: flex;
    align-items: center;
  }

  .bottom {
    flex-direction: column-reverse;
  }

  .left {

  }

  .baseline {
    position: relative;
    border-width: $border-width;
    transition-duration: $transition-duration;
    transition-property: transform;
    transition-timing-function: $transition-timing-function;

    .bottom &,
    .top & {
      border-top-style: solid;
      width: 100%;
      transform: scaleX(0);
    }

    .left &,
    .right & {
      border-left-style: solid;
      height: 100%;
      transform: scaleY(0);
    }

    .sidelines ~ & {
      transition-delay: $transition-duration;
    }

    .expanded & {
      transform: none;
      transition-delay: $transition-duration;
    }
  }

  .mark {
    $length: spacing(center-mark);

    position: relative;
    border-width: $border-width;
    transition: transform $transition-duration $transition-timing-function $transition-duration;

    .bottom &,
    .top & {
      border-left-style: solid;
      height: $length;
      transform: scaleY(0);
    }

    .bottom & {
      transform-origin: top;
    }

    .top & {
      transform-origin: bottom;
    }

    .right & {
      transform-origin: left;
    }

    .left & {
      transform-origin: right;
    }

    .left &,
    .right & {
      border-top-style: solid;
      width: $length;
      transform: scaleX(0);
    }

    .sidelines ~ & {
      transition-delay: $transition-duration * 2;
    }

    .expanded & {
      transform: none;
      transition-delay: 0ms;
    }
  }

  .right {
    flex-direction: row-reverse;
  }

  .sidelines {
    position: absolute;
    border-width: $border-width;
    width: 100%;
    height: 100%;
    transition-duration: $transition-duration;
    transition-property: transform;
    transition-timing-function: $transition-timing-function;

    .bottom &,
    .top & {
      border-right-style: solid;
      border-left-style: solid;
      transform: scaleY(0);
    }

    .left &,
    .right & {
      border-top-style: solid;
      border-bottom-style: solid;
      transform: scaleX(0);
    }

    .bottom & {
      transform-origin: bottom;
    }

    .top & {
      transform-origin: top;
    }

    .right & {
      transform-origin: right;
    }

    .left & {
      transform-origin: left;
    }

    .expanded & {
      transform: none;
      transition-delay: $transition-duration * 2;
    }
  }

  .top {
    flex-direction: column;
  }
</style>
